import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useFilters } from '../../hooks/projectFilters';
import Button from '../Button';
import ProModal from '../ProModal';

import { MenuAction, StyledBurger, HiddenMenu } from './styles';

const BurgerMenu = () => {
  const history = useHistory();
  const { isLoggedIn, userType, signOut } = useAuth();
  const { resetFilters, setPrice, setCurrentPage } = useFilters();

  const [isOpen, setOpen] = useState(false);
  const [proModalOpen, setProModal] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  function handleLinkClick() {
    setOpen(false);
  }

  function handleLoginButtonClick() {
    history.push('/login');
  }

  function handleProButtonClick() {
    setOpen(false);
    setProModal(true);
  }

  function handleProModalClose() {
    setProModal(false);
  }

  function handleLogoutButtonClick() {
    setOpen(false);
    signOut();
  }

  function closeMenu() {
    setOpen(false);
  }

  // Gratuitos deixou de ser uma página: virou o filtro de preço da listagem.
  function handleFreeProjectsClick() {
    resetFilters();
    setPrice('free');
    setCurrentPage(1);
    setOpen(false);
    history.push('/projects');
  }

  function renderMyAccountMenu() {
    return userType === 'designer' ? (
      <>
        <Link to="/designer/projects" onClick={closeMenu}>
          Meus projetos
        </Link>
        <Link to="/designer/remuneration" onClick={closeMenu}>
          Remuneração
        </Link>
        <Link to="/designer/wallet" onClick={closeMenu}>
          Minha carteira
        </Link>
        <Link to="/designer/profile" onClick={closeMenu}>
          Meus dados
        </Link>
        <Link to="/designer/buys" onClick={closeMenu}>
          Minhas compras
        </Link>
        <Link to="/designer/new-project" onClick={closeMenu}>
          Novo projeto
        </Link>
        <MenuAction type="button" onClick={handleLogoutButtonClick}>
          Sair do sistema
        </MenuAction>
      </>
    ) : (
      <>
        <Link to="/cutter/profile" onClick={closeMenu}>
          Meus dados
        </Link>
        <Link to="/cutter/projects" onClick={closeMenu}>
          Meus projetos
        </Link>
        <Link to="/cutter/courses" onClick={closeMenu}>
          Meus cursos
        </Link>
        <Link to="/cutter/wallet" onClick={closeMenu}>
          Minha carteira
        </Link>
        <MenuAction type="button" onClick={handleProButtonClick}>
          Me tornar PRO
        </MenuAction>
        <MenuAction type="button" onClick={handleLogoutButtonClick}>
          Sair do sistema
        </MenuAction>
      </>
    );
  }

  return (
    <>
      <ProModal isOpen={proModalOpen} onClose={handleProModalClose} />
      <StyledBurger
        type="button"
        open={isOpen}
        onClick={() => setOpen(!isOpen)}
        aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={isOpen}
      >
        <div />
        <div />
        <div />
      </StyledBurger>
      <HiddenMenu open={isOpen}>
        <Link to="/projects" onClick={handleLinkClick}>
          Explorar
        </Link>
        <MenuAction type="button" onClick={handleFreeProjectsClick}>
          Gratuitos
        </MenuAction>
        {isLoggedIn ? (
          <>
            <Link to="/favorites" onClick={handleLinkClick}>
              Favoritos
            </Link>
            <h2>Minha conta</h2>
            {renderMyAccountMenu()}
          </>
        ) : (
          <>
            <Link to="/register" onClick={handleLinkClick}>
              Cadastre-se
            </Link>
            <Button primary text="Entrar" onClick={handleLoginButtonClick} />
          </>
        )}
      </HiddenMenu>
    </>
  );
};

export default BurgerMenu;
